import { removerBreadcrumb2 } from "app/components/breadcrumb2/breadcrumb2Utils";
import { removerTodosComponentesReactDoConteudoPrincipal } from "app/components/renderizarOuRemoverComponentReact";
import { ControllerBase } from "../../../controllerBase";

const { PesquisarReservaController } = require('./pesquisarReservaController')
const { PedidoClienteController } = require('./pedidoClienteController')
const { PedidoFornecedorController } = require('./pedidoFornecedorController')
const { DataBreadcrumb } = require('../../../dataBreadcrumb')
const { EstoqueProdutoView } = require('../../views/produto/estoqueProdutoView')
const { Estoques } = require('../../models/produto/estoque')


declare var window: any

const PesquisarEstoqueController = ControllerBase.extend({
    name: "PesquisarEstoqueController",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Produto', prop: 'CodigoProduto' },
            { title: 'Descrição', prop: 'DescricaoProduto' }
        ],
        getData: function () {
            var modelAux = this.model.toJSON();

            if (modelAux.IdentificadorOrcamento) {
                modelAux.CodigoProduto = modelAux.CodigoProdutoExibicao;
            }

            return modelAux;
        },
    }),

    ajax: function () {

        var pesquisa = {
            TamanhoPagina: this.pesquisa ? this.pesquisa.PageSize : 20,
            NumeroPagina: this.pesquisa ? this.pesquisa.ActualPage : 1,
            Codigo: this.model.get("IdentificadorOrcamento") ? this.model.get("CodigoProduto") : this.model.get("Codigo"), // FNX-998, FNX-999, FNX-1001
            RetornaTodasAsFiliais: true
        };

        return {
            url: "/Produto/_Estoque",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString({
                pesquisa: pesquisa
            })
        };
    },


    renderizado: function () {

        $("#menu-sub-consulta-produtos").show();

        $("#reserva-item-menu").unbind();
        $("#reserva-item-menu").click($.proxy(this.pesquisarReservas, this));

        $("#pedido-cliente-item-menu").unbind();
        $("#pedido-cliente-item-menu").click($.proxy(this.pesquisarPedidoCliente, this));

        $("#pedido-fornecedor-item-menu").unbind();
        $("#pedido-fornecedor-item-menu").click($.proxy(this.pesquisarPedidoFornecedor, this));

        this.EstoqueProdutoView = this.showView({
            region: {
                name: "estoqueProdutoViewRegion",
                selector: "#pesquisar-estoque-produto-region"
            },
            view: {
                type: EstoqueProdutoView,
                args: {
                    model: this.model,
                    collection: new Estoques(this.collection)
                }
            }
        });

        this.atualizarTotais();

    },

    esconderContainers: function () {
        $("[container]").hide();

        removerTodosComponentesReactDoConteudoPrincipal()
        removerBreadcrumb2()
    },


    atualizarTotais: function () {


        $("#total-quantidade").html(global.formatNumber(this.collection
            .reduce(function (memo, value) { return memo + value.Quantidade }, 0),
            3));
        $("#total-reservado").html(global.formatNumber(this.collection
            .reduce(function (memo, value) { return memo + value.QuantidadeReservado }, 0),
            3));
        $("#total-disponivel").html(global.formatNumber(this.collection
            .reduce(function (memo, value) { return memo + value.QuantidadeDisponivel }, 0),
            3));
        $("#total-transito").html(global.formatNumber(this.collection
            .reduce(function (memo, value) { return memo + value.QuantidadeEmTransito }, 0),
            3));
        $("#total-pedido-fornecedor").html(global
            .formatNumber(this.collection
                .reduce(function (memo, value) { return memo + value.PedidosFornecedor }, 0),
                3));
        $("#total-nao-entregue-expedicao").html(global
            .formatNumber(this.collection.reduce(function (memo, value) { return memo + value.QtdeNaoEntregueExpedicao },
                0),
                3));
        $("#total-nao-entregue-futura").html(global
            .formatNumber(this.collection.reduce(function (memo, value) {
                return memo + value.QuantidadeNaoEntregueFutura
            },
                0),
                3));
        $("#total-disponivel-lote").html(global
            .formatNumber(this.collection.reduce(function (memo, value) { return memo + value.QuantidadeDisponivelLote },
                0),
                3));
    },

    pesquisarReservas: function () {

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar as reservas.");
            return;
        }

        this.pesquisarReservaController = this.showView({
            region: {
                name: "pesquisarReservaControllerRegion",
                selector: "#pesquisar-reserva-produto-container"
            },
            controller: {
                type: PesquisarReservaController,
                args: {
                    itemOrcamento: this.model,
                    produto: this.EstoqueProdutoView.model.get("CodigoProduto") +
                        " - " +
                        this.EstoqueProdutoView.model.get("DescricaoProduto")
                }
            }

        });
    },

    pesquisarPedidoCliente: function () {

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar os pedidos de clientes.");
            return;
        }

        this.pedidoClienteController = this.showView({
            region: {
                name: "pedidoClienteControllerRegion",
                selector: "#pesquisar-pedido-cliente-container"
            },
            controller: {
                type: PedidoClienteController,
                args: {
                    itemOrcamento: this.model,
                    produto: this.EstoqueProdutoView.model.get("CodigoProduto") +
                        " - " +
                        this.EstoqueProdutoView.model.get("DescricaoProduto")
                }
            }

        });
    },


    pesquisarPedidoFornecedor: function () {

        if (!this.model) {
            global.showErrorMessage("Selecione um produto antes de consultar os pedidos de fornecedores.");
            return;
        }

        console.log(this.model)

        this.pedidoFornecedorController = this.showView({
            region: {
                name: "pedidoFornecedorControllerRegion",
                selector: "#pesquisar-pedido-fornecedor-container"
            },
            controller: {
                type: PedidoFornecedorController,
                args: {
                    itemOrcamento: this.model,
                    produto: this.EstoqueProdutoView.model.get("CodigoProduto") +
                        " - " +
                        this.EstoqueProdutoView.model.get("DescricaoProduto")
                }
            }

        });
    },

    onhide: function (item) {
        $("#menu-sub-consulta-produtos").hide();
    }
})

window.PesquisarEstoqueController = PesquisarEstoqueController

export {
    PesquisarEstoqueController
}